module.exports = __webpack_public_path__ + "first-20-back.jpg?763cc506b1244f37796d36fc95e39b87";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20-back.jpg
// module id = 454
// module chunks = 0